export const checkIsMiniProgram = () => {
    return /miniProgram/i.test(navigator.userAgent.toLowerCase())
}